module.exports = __webpack_public_path__ + "static/IMG_8121-e6d4cbd5cecae2fe213bbd6b88ac8a8d.jpg";